<template>
  <div class="login">
    <!-- ヘッダー -->
    <SimpleHeader :productInfo="productInfo" />
    <div class="login-inner flexcenter">
      <div class="login-controls flexcenter">
        <h3 class="font22">ソースネクストへサインイン</h3>
        <div class="mail flexcenter">
          <input class="login-text" type="text" v-model="email" placeholder="メールアドレス (マイページID)" maxlength="128" @keypress.enter="doLogin()">
        </div>
        <div class="password flexcenter">
          <input class="login-text" type="password" v-model="password" placeholder="パスワード (英数半角4～16文字)" maxlength="16" @keypress.enter="doLogin()">
          <button class="enter" @click="doLogin()"><img src="static/images/icon/svg/ar_r_login.svg" alt="login"></button>
        </div>
        <p class="login-error m0" v-if="message">{{ message }}</p>
        <p>
          <a class="login-anchor" href="https://www.sourcenext.com/sc/users/rem_form?PID=login_form" target="_blank">
            メールアドレス、パスワードをお忘れですか？
          </a>
        </p>
        <p class="inline">
          ソースネクストアカウントをお持ちですか？
        </p>
        <p class="inline">
          <span>></span>
          <a class="login-anchor" href="https://www.sourcenext.com/sc/users/user_reg_auth" target="_blank">
            今すぐ作成
          </a>
        </p>
      </div><!-- /.login-controls -->
    </div><!-- /.inner -->
  </div><!-- /.login -->
</template>

<script>
import SimpleHeader from '@/components/Header'
import common from '@/mixin/common'
import http from '@/mixin/http'
import * as constants from '@/mixin/constants'
import Json from '../../static/data.json'

export default {
  name: 'login',
  data: function() {
    return {
      email: '',
      password: '',
      message: '',
      productInfo: Json.productInfo,
    }
  },
  components: {
    SimpleHeader
  },
  mixins: [
    common,
    http,
  ],
  methods: {
    /**
     * ログイン処理実行
     */
    doLogin: function () {
      var self = this
      self.log("Login start doLogin")

      // メールアドレスの先頭末尾の空白を除去
      self.email = self.email.trim()

      // ログインAPIを実行
      self.login(self.email, self.password)
        .then(function(response) {
          self.log("Login login resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              storage_wrapper.setRsAccessKey(response.access_key)
              self.$router.replace({ name: 'Root' })
              break
            case 'WARN_INPUT_PARAM':
            case 'INFO_INVALID_USER':
              self.error(constants.ERR_INVALID_USER)
              break
            case 'INFO_USER_LOCKED':
              self.error(constants.ERR_USER_LOCKED)
              break
            default:
              self.error(constants.ERR_UNKNOWN)
              break
          }
        })
        .catch(function(err) {
          self.error(constants.ERR_UNKNOWN)
        })
    },
    /**
     * エラー処理
     *
     * @param {String} message エラーメッセージ
     */
    error: function(message) {
      this.message = message
      this.password = ''
    },
  },
  mounted: function() {
    // ローカルストレージ操作初期化処理
    storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN)
    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1){
      this.fixtHeightForSafariFullWindow()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/login';
</style>



// WEBPACK FOOTER //
// Login.vue?03b4f4a9